import React, { useState } from 'react';
import CategoryPerformance from './CategoryPerformance';

const CategoryInsights = ({ data }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  return (
    <div className="space-y-6">
      <CategoryPerformance 
        data={data} 
        onSelectCategory={(category) => setSelectedCategory(category)} 
      />
    </div>
  );
};

export default CategoryInsights; 